import { render, staticRenderFns } from "./DriverEdit.vue?vue&type=template&id=04ceabf2&scoped=true"
import script from "./DriverEdit.vue?vue&type=script&lang=js"
export * from "./DriverEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ceabf2",
  null
  
)

export default component.exports